module.exports = __webpack_public_path__ + "img/resource-tech-image-47.c99459b6.jpg";